import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { OemApplication } from './features/oem/application';
import { PwaUpdatePrompt } from './components/pwa-update-prompt';
import './i18n';
import { router } from './routes/router';
import './styles/app.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});
const root = document.querySelector('#root');

if (root === null) throw new Error('Application root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {window.location.pathname.startsWith('/proposal/') ? (
        <RouterProvider router={router} />
      ) : (
        <OemApplication />
      )}
      <PwaUpdatePrompt />
    </QueryClientProvider>
  </StrictMode>,
);
